/**
 * Renders *emphasised* spans inside a CMS string as <em>.
 *
 * Two case-study paragraphs italicise the search phrases a customer actually types.
 * Flattening them to plain text would lose that emphasis, and modelling the
 * paragraph as a list of segments would make it miserable to edit — so the field
 * holds the sentence as written, with asterisks around the emphasised parts.
 */
export function Emphasis({ text }: { text: string }) {
  if (!text.includes('*')) return <>{text}</>
  const parts = text.split(/\*([^*]+)\*/g)
  return (
    <>
      {parts.map((part, i) => (i % 2 === 1 ? <em key={i}>{part}</em> : part))}
    </>
  )
}
